import { render, staticRenderFns } from "./SalesOrderSubsidizedInvoiceMailForm.vue?vue&type=template&id=0523aa0c"
import script from "./SalesOrderSubsidizedInvoiceMailForm.vue?vue&type=script&lang=js"
export * from "./SalesOrderSubsidizedInvoiceMailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports